import * as React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { LogoutButton } from '../../Authentification/Logout/LogoutButton';

import './MetaNavigation.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './MetaNavigation.messages';
import { formatMessage } from 'src/api';
import TermsModal from '../../Localize/TermsModal';

export interface MetaNavigationProps {
}

export default class MetaNavigationPartial extends React.Component<MetaNavigationProps, any> {
  constructor(props: MetaNavigationProps) {
    super(props);
    this.state = {
      showTerms: false,
    };
  }

  public render() {
    return (
      <div className="partial-meta-navigation text-center d-block">
          <div className="container-fluid w-100">
            <div className="row">
              <div className="col-12 col-12 col-lg-8 offset-lg-4 partial-meta text-center">
                  <ul className="p-0 text-center w-100 d-block">
                    <li className="d-block pl-4 pr-4 small mb-2">
                      <NavLink to="/imprint" activeClassName="active">
                        <FormattedMessage {...MESSAGES.metaNavigationImprint} />
                      </NavLink>
                    </li>
                    <li className="d-block pl-4 pr-4 small mb-2">
                      <a href="#privacy-policy" onClick={(e) => {
                        var button = (document as any).getElementById('usercentrics-root').shadowRoot.querySelector('[data-testid="uc-privacy-button"]');
                        button.click();
                        
                        e.preventDefault();
                        return false;
                      }}>
                        <FormattedMessage {...MESSAGES.metaNavigationPrivacy} />
                      </a>
                    </li>
                    <li className="d-block pl-4 pr-4 small mb-2">
                      <a href="https://kwc-professional.com/en_global/footer-pages/terms-and-conditions" target="_blank" 
                        onClick={(e) => {
                          e.preventDefault(); 
                          this.setState({showTerms: true})
                        }}>
                        <FormattedMessage {...MESSAGES.metaNavigationLegals} />
                      </a>
                    </li>
                  </ul>
                  <LogoutButton />
              </div>
            </div>
        </div>
        {this.state.showTerms && (
          <TermsModal 
            drilledClose={() => {
              this.setState({showTerms: false});
            }}
          />
        )}
      </div>
    );
  }
}
